import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "configurator w-screen h-screen subpixel-antialiased overflow-y-hidden" }
const _hoisted_2 = { class: "configurator-header p-4 px-6 md:p-6 md:px-10 flex justify-between items-center w-full" }
const _hoisted_3 = ["hidden"]
const _hoisted_4 = { class: "configurator-footer p-4 px-6 md:p-6 md:px-10 flex justify-end items-center w-full" }
const _hoisted_5 = ["hidden"]
const _hoisted_6 = ["hidden"]
const _hoisted_7 = ["hidden", "disabled"]
const _hoisted_8 = ["hidden", "disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader = _resolveComponent("loader")!
  const _component_configurator = _resolveComponent("configurator")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => {_ctx.configuratorEnabled && _ctx.$router.push({ path: '/start' });}),
        class: _normalizeClass(["logo-image", {'cursor-pointer': _ctx.configuratorEnabled}]),
        src: "https://salesqueze-production-fs.s3.eu-central-1.amazonaws.com/oblak/assets/logo.png"
      }, null, 2),
      _createElementVNode("div", {
        class: "text-gray-400",
        hidden: !_ctx.configuratorEnabled || this.$router.currentRoute.value.name === 'Done'
      }, [
        _createElementVNode("span", null, _toDisplayString(_ctx.$t("Korak")) + " " + _toDisplayString(this.$router.getRoutes().flatMap(x => x.name).indexOf(this.$router.currentRoute.value.name) + 1) + "/" + _toDisplayString(this.$router.getRoutes().length -2), 1)
      ], 8, _hoisted_3)
    ]),
    _createVNode(_component_loader, {
      active: _ctx.loaderActive,
      class: "w-screen h-screen loader-position"
    }, null, 8, ["active"]),
    _createVNode(_component_configurator),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", {
        class: "flex items-center gap-x-5",
        hidden: !_ctx.configuratorEnabled || this.$router.currentRoute.value.name === 'Done'
      }, [
        _createElementVNode("button", {
          type: "button",
          class: "app-button-secondary",
          hidden: this.$router.currentRoute.value.meta.prev === '',
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleClickBack && _ctx.handleClickBack(...args)))
        }, _toDisplayString(_ctx.$t("Nazaj")), 9, _hoisted_6),
        _createElementVNode("button", {
          type: "button",
          class: "app-button-primary",
          hidden: this.$router.currentRoute.value.meta.next === '',
          disabled: _ctx.nextDisabled,
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleClickNext && _ctx.handleClickNext(...args)))
        }, _toDisplayString(_ctx.$t("Naprej")), 9, _hoisted_7),
        _createElementVNode("button", {
          type: "button",
          class: "app-button-finish",
          hidden: this.$router.currentRoute.value.name !== 'Sales salon',
          disabled: _ctx.submitDisabled,
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)))
        }, _toDisplayString(_ctx.$t("Oddaj povpraševanje")), 9, _hoisted_8)
      ], 8, _hoisted_5)
    ])
  ]))
}